import {
  PersonalInfoFormValues,
  PersonalInfoFormViolation,
} from 'types/personalInfoTypes';
import { stringIsEmpty, stringLengthMoreThan } from 'utils/stringUtils';
import { PROD_STACK_POSITION_MAX_LENGTH } from 'utils/constants';

export const validatePersonalInfoFormValuesImmediately = (
  values: PersonalInfoFormValues
): PersonalInfoFormViolation[] => {
  const violations: PersonalInfoFormViolation[] = [];

  if (stringLengthMoreThan(values.position, PROD_STACK_POSITION_MAX_LENGTH)) {
    violations.push({
      name: 'PositionTooLong',
    });
  }

  return violations;
};

export const validatePersonalInfoFormValues = (
  values: PersonalInfoFormValues
): PersonalInfoFormViolation[] => {
  const violations: PersonalInfoFormViolation[] = validatePersonalInfoFormValuesImmediately(
    values
  );

  if (stringIsEmpty(values.firstName)) {
    violations.push({
      name: 'FirstNameMissed',
    });
  }

  if (stringIsEmpty(values.lastName)) {
    violations.push({
      name: 'LastNameMissed',
    });
  }

  if (stringIsEmpty(values.middleName)) {
    violations.push({
      name: 'MiddleNameMissed',
    });
  }

  if (stringIsEmpty(values.position)) {
    violations.push({
      name: 'PositionMissed',
    });
  }

  const joinedPartnerCode = values.partnerCode.join('').trim();

  if (joinedPartnerCode.length > 0 && joinedPartnerCode.length < 4) {
    violations.push({
      name: 'InvalidPartnerCode',
    });
  }

  return violations;
};

export const createPersonalFormViolationLense = (
  violation: PersonalInfoFormViolation
) => ({
  isFirstNameViolation() {
    switch (violation.name) {
      case 'FirstNameMissed':
        return true;
      default:
        return false;
    }
  },
  isLastNameViolation() {
    switch (violation.name) {
      case 'LastNameMissed':
        return true;
      default:
        return false;
    }
  },
  isMiddleNameViolation() {
    switch (violation.name) {
      case 'MiddleNameMissed':
        return true;
      default:
        return false;
    }
  },
  isPositionViolation() {
    switch (violation.name) {
      case 'PositionMissed':
      case 'PositionTooLong':
        return true;
      default:
        return false;
    }
  },
  isPartnerCodeViolation() {
    switch (violation.name) {
      case 'PartnerNotFound':
      case 'InvalidPartnerCode':
        return true;
      default:
        return false;
    }
  },
});
